<div class="data-collaborator">
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelIdentificator">CPF:</p>
        <p class="info-value" data-test="valueIdentificator" #numeroCpf>{{ infos?.identificator }}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyIdentificator'" [label]="infos?.identificator"></up-ui-copy-button>
    </div>

    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelBirthdate">Data de nascimento:</p>
        <p class="info-value" data-test="valueBirthdate">{{infos?.birthdate | date: 'dd/MM/yyyy'}}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyBirthdate'" [label]="infos?.birthdate | date: 'dd/MM/yyyy'"></up-ui-copy-button>
    </div>
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelRole">Cargo:</p>
        <p class="info-value" data-test="valueRole">{{ roleName || '--' }}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyRole'" [label]="roleName"></up-ui-copy-button>
    </div>
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelDepartment">Departamento:</p>
        <p class="info-value" data-test="valueDepartment">{{  departmentName || '--' }}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyDepartment'" [label]="departmentName"></up-ui-copy-button>
    </div>
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelUnit">Filial:</p>
        <p class="info-value" data-test="valueUnit">{{ unitName || '--'}}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyUnit'" [label]="unitName"></up-ui-copy-button>
    </div>
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelRelation">Vínculo de contratação:</p>
        <p class="info-value" data-test="valueRelation">{{infos?.admission?.relation || '--' | accents | uppercase }}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyRelation'" [label]="infos?.admission?.relation"></up-ui-copy-button>
    </div>
    <app-salary-collaborator [value]="infos?.admission?.salary"></app-salary-collaborator>
</div>
